module.exports = __webpack_public_path__ + "koa.cbb7c3.svg";